module.exports = __webpack_public_path__ + "img/戒台寺.25b5d15f.png";